import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { map } from 'rxjs/operators';
import { PracticeSetupStepValidation } from './practice-setup-step-validation';
import {
  IPageVisitTrackingConfig,
  IPracticeSetupStepDefinition,
} from './practice-setup-step.types';
import { initRawSchema, toParagraphContent } from '@principle-theorem/editor';

const pageVisitTracking: IPageVisitTrackingConfig = {
  routes: ['settings/brand/{brandId}/custom-forms'],
  validationMode: 'any',
};

export const customFormsStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.CustomForms,
  category: PracticeSetupStepCategory.Miscellaneous,
  title: 'Create Your Custom Forms',
  description: initRawSchema([
    toParagraphContent(
      `In addition to the Medical History Form, Principle allows you to create and manage a library of digital Custom Forms that can be sent to patients before or after their appointments. These forms can serve a wide range of purposes, including consent forms, feedback questionnaires, new patient intake forms, and anything else your practice requires patients to complete.`
    ),
    toParagraphContent(
      `These forms are fully customisable using a drag and drop editor, giving you control over exactly what information is collected from your patients. If you are migrating from a compatible Practice Management Software, existing medical conditions and allergies can be mapped directly to fields on the Medical History Form. Ensure all relevant fields are present on the medical history form to complete this step.`
    ),
  ]),
  dependsOn: [],
  getRoute: (brand, _practice) => `settings/brand/${brand.ref.id}/custom-forms`,
  validate$: (practice$, step, options) => {
    return practice$.pipe(
      map((_practice) => {
        if (options?.reviewed || options?.skipped) {
          return { valid: true };
        }

        const pageVisitValidation =
          PracticeSetupStepValidation.validatePageVisits(
            step,
            pageVisitTracking
          );
        if (pageVisitValidation.valid) {
          return { valid: true };
        }

        return {
          valid: false,
          reason: 'Please review this page to complete this step',
        };
      })
    );
  },
  pageVisitTracking,
};
